import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { IGroup } from '../../types/group'
import { ISearch, IQuery, SortOptions, FilterOptions } from '../../types/search'
import { IOption } from '../../types/common'
import { IGroupParam } from '../../types/router'
import { getGroups } from '../../actions/groups'
import { parseNestedQuery, dateCaptions } from '../../services/search'
import { useSearch } from '../../hooks'
import { BlueThemeProvider } from '../../styles'
import { Main } from '../../layouts'
import {
  H1,
  PackList,
  ControlledInfiniteScroll,
  SearchFilters,
  SortByDropdown,
  Breadcrumbs,
} from '../../components'
import { TitleBlockWrapper } from '../ConsumerSearchPage/styled'

export interface ISearchPageConnectedProps {
  search: ISearch
  groupsLoading: boolean
  groupsLoaded: boolean
  group?: IGroup
  dispatch: Dispatch
}

const options: { [key: string]: IOption } = {
  [SortOptions.modified]: {
    label: dateCaptions.modified,
    value: SortOptions.modified,
  },
  [SortOptions.nextScheduleDate]: {
    label: dateCaptions.nextScheduleDate,
    value: SortOptions.nextScheduleDate,
  },
  [SortOptions.expiryDate]: {
    label: dateCaptions.expiryDate,
    value: SortOptions.expiryDate,
  },
  [SortOptions.relevance]: { label: 'Relevance', value: SortOptions.relevance },
}

export const SearchPage = ({
  search,
  dispatch,
  match: {
    params: { groupId },
  },
  location,
  group,
  groupsLoading,
  groupsLoaded,
}: ISearchPageConnectedProps & RouteComponentProps<IGroupParam>) => {
  const params = parseNestedQuery(location.search)
  const [takeNextChunk, updateFilters] = useSearch({
    search,
    location,
    groupId,
    isConsumer: false,
    dispatch,
  })
  const sortedOptions = ({ date }: IQuery): IOption[] => [
    date === FilterOptions.nextScheduleDate
      ? options.nextScheduleDate
      : date === FilterOptions.expiryDate
      ? options.expiryDate
      : options.modified,
    options.relevance,
  ]
  useEffect(() => {
    if (!groupsLoaded && !groupsLoading) {
      dispatch(getGroups())
    }
  }, [dispatch, groupsLoading, groupsLoaded])
  return (
    <BlueThemeProvider>
      <Main
        header={group && <Breadcrumbs group={group} />}
        sidebarSecondary={
          <SearchFilters
            groupId={groupId}
            setFilters={updateFilters}
            theme="blue"
            isConsumer={false}
            groups={[]}
          />
        }
        titleBlock={
          <TitleBlockWrapper>
            <H1>Search results</H1>
            <SortByDropdown
              filterValues={params}
              sortTypes={sortedOptions(params)}
              updateFilters={updateFilters}
            />
          </TitleBlockWrapper>
        }
        helmet={group && `Reuters Graphics: ${group.shortTitle}`}
      >
        <ControlledInfiniteScroll
          component={PackList}
          takeNextChunk={takeNextChunk}
          search={{ ...search }}
        />
      </Main>
    </BlueThemeProvider>
  )
}
